/**
 * Default status options for Company Policies
 */
export const COMPANY_POLICIES_STATUS_OPTIONS = [
  { value: "初期作成中", text: "初期作成中", is_auto_select: true },
  { value: "公開", text: "公開", is_auto_select: true },
  { value: "改定中", text: "改定中", is_auto_select: true },
  { value: "使用禁止", text: "使用禁止", is_auto_select: true },
];

/**
 * Default category options for Company Policies
 */
export const COMPANY_POLICIES_CATEGORY_OPTIONS = [
  { value: "営業/販売(Sales)", text: "営業/販売(Sales)", is_auto_select: true },
  { value: "購買/商品(Pha", text: "購買/商品(Pha", is_auto_select: true },
  { value: "人事/組織(Human)", text: "人事/組織(Human)", is_auto_select: true },
  {
    value: "情報/ＩＴ(Information)",
    text: "情報/ＩＴ(Information)",
    is_auto_select: true,
  },
  { value: "経営", text: "経営", is_auto_select: true },
  { value: "総務", text: "総務", is_auto_select: true },
  { value: "財務・会計", text: "財務・会計", is_auto_select: true },
  {
    value: "リスクマネジメント",
    text: "リスクマネジメント",
    is_auto_select: true,
  },
  { value: "人事・労務", text: "人事・労務", is_auto_select: true },
  { value: "営業・購買", text: "営業・購買", is_auto_select: true },
  { value: "営業/販売", text: "営業/販売", is_auto_select: true },
];
